import { useCallback, useEffect, useRef, useState } from 'react'

import { LeadPayload, LeadSubmissionError, submitLead } from 'shared/lib/lead-submission'

export const useLeadSubmission = () => {
    const [pending, setPending] = useState(false)
    const [error, setError] = useState<string | null>(null)
    const inFlight = useRef(false)
    const mounted = useRef(true)

    useEffect(() => () => {
        mounted.current = false
    }, [])

    const submit = useCallback(async (payload: LeadPayload): Promise<boolean> => {
        if (inFlight.current) return false

        inFlight.current = true
        if (mounted.current) {
            setPending(true)
            setError(null)
        }
        try {
            await submitLead(payload)
            return true
        } catch (submissionError) {
            if (mounted.current) {
                setError(
                    submissionError instanceof LeadSubmissionError
                        ? submissionError.message
                        : 'Не удалось отправить заявку.',
                )
            }
            return false
        } finally {
            inFlight.current = false
            if (mounted.current) setPending(false)
        }
    }, [])

    return { pending, error, submit }
}
